import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";

export default function Dashboard() {
  return (
    <Box p={3}>
      <Typography variant="h4" mb={3}>
        Dashboard
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography>Total GRNs</Typography>
            <Typography variant="h5">120</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography>Pending</Typography>
            <Typography variant="h5">32</Typography>
          </Paper>
        </Grid>

        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography>Completed</Typography>
            <Typography variant="h5">88</Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}